import classname from 'classname';
import Badge from 'components/Badge';
import Pagination from 'components/common/pagination';
import EmptyState from 'components/EmptyState';
import Fetching from 'components/Fetching';
import Table from 'components/Form/Table';
import { CaretRightIcon } from 'components/icons';
import { formatWithCommas } from 'libs';
import moment from 'moment';
import React from 'react';
import { globalStyles } from 'styles';
import Transactiondetails from './transactiondetails';

export default function TransactionTable({
  columnsToshow,
  txt,
  statusTextColorMapping,
  meta,
  handlePageClick,
  inProgress,
  currentPage,
  hidePagination = false,
}) {
  const [drawerActive, setDrawerActive] = React.useState(false);
  const [currentDetail, setCurrentDetail] = React.useState({});

  return (
    <>
      <>
        <Transactiondetails
          drawerActive={drawerActive}
          setDrawerActive={setDrawerActive}
          txtRow={currentDetail}
        />
        {inProgress && <Fetching />}
        {txt && txt.length === 0 && !inProgress && (
          <EmptyState text="Your transactions will show up here as they are being made" />
        )}
        {txt && txt.length > 0 && !inProgress && (
          <>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columnsToshow.id && (
                    <Table.Th>Transaction Reference</Table.Th>
                  )}
                  {columnsToshow.terminalId && <Table.Th>ID</Table.Th>}
                  {columnsToshow.productName && (
                    <Table.Th>Product name</Table.Th>
                  )}
                  {columnsToshow.productCode && (
                    <Table.Th>Product Code</Table.Th>
                  )}
                  {columnsToshow.amount && <Table.Th>Amount</Table.Th>}
                  {columnsToshow.paymentDate && (
                    <Table.Th>Payment date</Table.Th>
                  )}
                  {columnsToshow.status && <Table.Th>Status</Table.Th>}
                </Table.Tr>
              </Table.Thead>
              <Table.TBody>
                {txt.map((txtRow) => (
                  <Table.Tr key={txtRow.id} data-testid="transaction-row">
                    {columnsToshow.id && (
                      <Table.Td>
                        {txtRow.parentReference
                          ? `${txtRow.parentReference.substr(0, 15)}...`
                          : '-'}
                      </Table.Td>
                    )}
                    {columnsToshow.terminalId && (
                      <Table.Td>{txtRow.id ? txtRow.id : '-'}</Table.Td>
                    )}
                    {columnsToshow.productName && (
                      <Table.Td>{txtRow?.meta?.product_name}</Table.Td>
                    )}
                    {columnsToshow.productCode && (
                      <Table.Td>{txtRow?.meta?.product_code}</Table.Td>
                    )}
                    {columnsToshow.amount && (
                      <Table.Td>₦{formatWithCommas(txtRow.amount)}</Table.Td>
                    )}
                    {columnsToshow.paymentDate && (
                      <Table.Td>
                        {moment(txtRow.createdAt).format('MMM D, YYYY LT')}
                      </Table.Td>
                    )}
                    {columnsToshow.status && (
                      <Table.Td>
                        <div
                          className={classname(
                            globalStyles.flex,
                            globalStyles.justifyContentBetween,
                          )}
                        >
                          <Badge
                            color={statusTextColorMapping[txtRow.status]?.color}
                          >
                            {statusTextColorMapping[txtRow.status]?.text}
                          </Badge>
                          <button
                            onClick={() => {
                              setCurrentDetail(txtRow);
                              setDrawerActive(true);
                            }}
                          >
                            <CaretRightIcon
                              fill="#18379A"
                              style={{ marginLeft: '30px' }}
                            />
                          </button>
                        </div>
                      </Table.Td>
                    )}
                  </Table.Tr>
                ))}
              </Table.TBody>
            </Table>
          </>
        )}
      </>
      {!inProgress && !hidePagination && (
        <div
          className={classname(
            globalStyles.flex,
            globalStyles.justifyContentBetween,
            globalStyles.alignItemsCenter,
          )}
        >
          <p className={globalStyles.pagination}>
            Showing{' '}
            {meta.page === 0 ? txt.length : txt.length * (meta.page + 1)} items
            out of {Math.ceil(meta.total / meta.limit)}
            {Math.ceil(meta.total / meta.limit) > 1 ? ' pages' : ' page'} found
          </p>
          <div data-testid="pagination">
            <Pagination
              currentPage={currentPage}
              handlePageClick={handlePageClick}
              totalItems={Math.ceil(meta.total / meta.limit)}
            />
          </div>
        </div>
      )}
    </>
  );
}
